import { supabase } from '@/lib/supabase'

export type HeaderWarningModule = 'analysis' | 'vision' | 'chat'

const KEY_MAP: Record<HeaderWarningModule, string> = {
  analysis: 'ui.analysis.header_warning_text',
  vision: 'ui.vision.header_warning_text',
  chat: 'ui.chat.header_warning_text',
}

export async function getModuleHeaderWarningText(module: HeaderWarningModule): Promise<string> {
  const key = KEY_MAP[module]
  const { data, error } = await supabase.from('app_settings').select('value').eq('key', key).maybeSingle()
  if (error) throw error
  return String((data as any)?.value || '').trim()
}

export async function setModuleHeaderWarningText(
  module: HeaderWarningModule,
  text: string,
): Promise<void> {
  const key = KEY_MAP[module]
  const value = String(text || '').trim()
  const { error } = await supabase.from('app_settings').upsert({ key, value }, { onConflict: 'key' })
  if (error) throw error
}
